import { Component, Input, OnChanges } from '@angular/core';
import { FirstLetterPipe } from '../../pipes/first-letter.pipe';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { BackgroundImageDirective } from '../../directives/background-image.directive';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { EmptyIndicatorPipe } from '../../pipes/empty-indicator.pipe';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-avatar',
  imports: [
    FirstLetterPipe,
    NgClass,
    BackgroundImageDirective,
    TooltipModule,
    EmptyIndicatorPipe,
    NgbTooltip,
    NgTemplateOutlet,
  ],
  templateUrl: './avatar.component.html',
})
export class AvatarComponent implements OnChanges {
  @Input() imageUrl?: string = '';
  @Input() size: string = 'md'; // expected: xs, sm, md, lg, xl, xxl
  @Input() toolTip?: string = '';
  @Input() toolTipPosition: string = 'auto';
  @Input() disableTooltip: boolean = true;
  @Input() class?: string = ''; // options: 'avatar--bg-primary', 'avatar--bg-secondary', 'no-bg', 'avatar--border-custom'
  @Input() type: string = 'profile'; // expected 'profile', 'logo', 'initials'
  @Input() iconClass: string = 'iconoir-user'; // expected icon font class
  @Input() firstName: string | undefined = '';
  @Input() lastName: string | undefined = '';

  initialsColorClass: string = '';

  ngOnChanges() {
    if (this.firstName?.length) {
      const letter = Number(this.firstName[0]) ? 'undefined' : this.firstName[0];
      this.initialsColorClass = 'avatar__initials-bg-' + letter.toLowerCase();

      // set default tooltip
      if (!this.toolTip?.length) {
        this.toolTip = this.firstName + ' ' + this.lastName;
      }
    }
  }
}
